import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import PageLayout from '../../../../components/PageLayout';
import EventListItem from '../../../../components/EventListItem';
import { Action, GET, JSXMap, errorCatch, useAuth } from 'fennec-ui';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { useNearestObjectContext } from '../../../../../common/Context';
import { getRGBAColor } from '../../../../../common/Tool';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import copy from 'copy-to-clipboard';
import ObjectVtpDescription from '../../../../../fedance-ui/ObjectVtpDescription';
import { message } from 'antd';
import { Button, Checkbox, Form } from 'antd-mobile';
import User from '../../../../../common/User';

var _ = require('lodash');

var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function PromoRole(props) {
    let { id } = useParams();
    const auth = useAuth()
    const { event } = props;

    // console.log("PromoRole", event);

    const [vtp, setContextObject] = useNearestObjectContext()

    // "/api/promokodi/get-promouter-promokod/{meropriyatieID}/{vtpID}"
    // "/api/promokodi/create-promouter-promokod/{meropriyatieID}/{vtpID}"

    // "/api/agentskie-voznagrazhdeniya/fill/{meropriyatieID}"

    const [checkLoading, setCheckLoading] = useState(false);
    const [createLoading, setCreateLoading] = useState(false);
    const [promokod, setPromokod] = useState();

    const create = useCallback(() => {
        setCreateLoading(true)
        GET(auth, `/api/promokodi/create-promouter-promokod/${event?.ID}/${vtp?.ID}`,
            ({ data }) => {
                setCreateLoading(false)
                // console.log(data);
                if (data?.promokod || data?.promokodiPrepodov2Uroven?.length) {
                    setPromokod(o => {
                        return ({
                            ...o,
                            ...(data?.promokod) ? { promokod: data?.promokod } : {},
                            ...(data?.promokodiPrepodov2Uroven?.length) ? { promokodiPrepodov2Uroven: [...(o?.promokodiPrepodov2Uroven) ? o?.promokodiPrepodov2Uroven : [], ...data?.promokodiPrepodov2Uroven] } : {}
                        })
                    })
                }
            }, (err) => errorCatch(err, () => { setCreateLoading(false) }));
    }, [auth, vtp, event, setPromokod])

    useEffect(() => {
        if (event?.ID && vtp?.ID) {
            setCheckLoading(true)
            GET(auth, `/api/promokodi/get-promouter-promokod/${event?.ID}/${vtp?.ID}`,
                ({ data }) => {
                    // console.log(data);
                    setCheckLoading(false)
                    if (data.promokod) {
                        setPromokod(data)
                    } else {
                        create()
                    }
                }, (err) => errorCatch(err, () => { setCheckLoading(false) }));
        }
    }, [event])

    const xName = (item) => {
        if (item?.kollektivID) {
            return "kollektiv"
            // return item?.kollektivID;
        } else if (item?.meropriyatieID) {
            return "event"
            // return item?.meropriyatieID;
        } else if (item?.organizatorID) {
            return "organizer";
            // return item?.organizatorID;
        } else if (item?.paraID) {
            return "para"
            // return item?.paraID;
        } else if (item?.prepodavatelID) {
            return "teacher";
            // return item?.prepodavatelID;
        } else if (item?.regionalnoeOtdelenieID) {
            return "local"
            // return item?.regionalnoeOtdelenieID;
        } else if (item?.shkolaID) {
            return "school"
            // return item?.shkolaID;
        } else if (item?.sudyaID) {
            return "sudya";
            // return item?.sudyaID;
        } else if (item?.tantsorID) {
            return "tantsor";
            // return item?.tantsorID;
        } else if (item?.chlenFederatsiiID) {
            return "member";
            // return item?.chlenFederatsiiID;
        }
    }
    const xID = (item) => {
        if (item?.kollektivID) {
            // return "kollektiv"
            return item?.kollektivID;
        } else if (item?.meropriyatieID) {
            // return "event"
            return item?.meropriyatieID;
        } else if (item?.organizatorID) {
            // return "organizer";
            return item?.organizatorID;
        } else if (item?.paraID) {
            // return "para"
            return item?.paraID;
        } else if (item?.prepodavatelID) {
            // return "teacher";
            return item?.prepodavatelID;
        } else if (item?.regionalnoeOtdelenieID) {
            // return "local"
            return item?.regionalnoeOtdelenieID;
        } else if (item?.shkolaID) {
            // return "school"
            return item?.shkolaID;
        } else if (item?.sudyaID) {
            // return "sudya";
            return item?.sudyaID;
        } else if (item?.tantsorID) {
            // return "tantsor";
            return item?.tantsorID;
        } else if (item?.chlenFederatsiiID) {
            // return "member";
            return item?.chlenFederatsiiID;
        }
    }

    const buildData = React.useCallback((values) => {
        // console.log(values);
        let str = ""
        str = str.concat(`${event?.nazvanieMeropriyatiya}\n`)
        str = str.concat(`${dayjs(event?.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}, ${dayjs(event?.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}\n`)
        str = str.concat(`● ${promokod?.promokod?.Promokod?.promokod}\n`)

        if (!values?.short) {
            str = str.concat(`Скидка по промокоду для покупателя:\n`)
            for (let index = 0; index < promokod?.promokod?.Promokod?.promokodiVYacheikakhPromokod.length; index++) {
                const e = promokod?.promokod?.Promokod?.promokodiVYacheikakhPromokod[index];
                if (e?.yacheikaUslugi) {
                    str = str.concat(`- ${e?.yacheikaUslugi?.nazvanie} (`)
                    str = str.concat(`${(!!e?.protsentObshcheiSummiUslugiNaMeropriyatii) ? e?.protsentObshcheiSummiUslugiNaMeropriyatii + "%" : ""}`)
                    str = str.concat(`${(!!e?.rubleiOtObshcheiSummiUslugiNaMeropriyatii) ? e?.rubleiOtObshcheiSummiUslugiNaMeropriyatii + " руб." : ""}`)
                    str = str.concat(`)\n`)
                }
            }
        }
        str = str.concat(`\n`)

        if (promokod?.promokodiPrepodov2Uroven?.length > 0) {
            str = str.concat(`Преподаватели школы:\n`)
            for (let index = 0; index < promokod?.promokodiPrepodov2Uroven?.length; index++) {
                const item = promokod?.promokodiPrepodov2Uroven[index];
                if (!item?.ErrorText && item?.Promokod) {
                    str = str.concat(`● ${item?.Promokod?.promokod} - `)
                    str = str.concat(`${(item?.Vtp?.user?.lastname) ? item?.Vtp?.user?.lastname + " " : ""}${(item?.Vtp?.user?.firstname) ? item?.Vtp?.user?.firstname + " " : ""}${(item?.Vtp?.user?.patronymic) ? item?.Vtp?.user?.patronymic : ""}`)
                    str = str.concat(`\n`)
                }
                if (!values?.short) {
                    str = str.concat(`Скидка по промокоду для покупателя:\n`)
                    for (let index = 0; index < item?.Promokod?.promokodiVYacheikakhPromokod.length; index++) {
                        const e = item?.Promokod?.promokodiVYacheikakhPromokod[index];
                        if (e?.yacheikaUslugi) {
                            str = str.concat(`- ${e?.yacheikaUslugi?.nazvanie} (`)
                            str = str.concat(`${(!!e?.protsentObshcheiSummiUslugiNaMeropriyatii) ? e?.protsentObshcheiSummiUslugiNaMeropriyatii + "%" : ""}`)
                            str = str.concat(`${(!!e?.rubleiOtObshcheiSummiUslugiNaMeropriyatii) ? e?.rubleiOtObshcheiSummiUslugiNaMeropriyatii + " руб." : ""}`)
                            str = str.concat(`)\n`)
                        }
                    }
                }
            }
        }
        str = str.concat(`\n`)

        return str
    }, [event, promokod])


    // var color = getIndexColorLighter(promokod?.promokod?.Promokod?.ID || 1, 0.25)
    var color = getRGBAColor(50, 50, 50, 0.05)
    return (
        <PageLayout hideSider={true}>
            <div style={{ height: "100%", overflowY: "scroll", backgroundColor: "white", borderRadius: "4px" }}>
                {promokod?.promokod?.ErrorText && <div style={{ display: "flex", alignItems: "center", padding: "0 10px" }}>
                    {/* <img style={{ width: "140px" }} src='/resources/error.webp' /> */}
                    <div>
                        <div style={{ color: "red", fontSize: "18px" }}>{promokod?.promokod?.ErrorText}</div>
                        <div>Вы можете указать основу промокода в разделе <Link to={`/app/${xName(promokod?.promokod?.Vtp)}/${xID(promokod?.promokod?.Vtp)}/settings`}>"Настройки" в личном кабинете</Link></div>
                    </div>
                </div>}
                {promokod?.promokod?.Promokod && <div>
                    {event && <EventListItem
                        key={"event"}
                        event={event}
                        hideRoles={true}
                        hidePreview={true}
                        // noNameLink={true}
                        // hideBuyButton={true}
                        hideDetailButton={true}
                        imageSize={110}
                        hideKategorii={true}
                        size={"small"}
                        extButtons={({ style, size, path }) => <Action
                            readonly={false}
                            auth={auth}
                            action={(values, unlock, close) => {
                                if (copy(values?.request?.text || "")) {
                                    message.success("Скопировано", 1, close);
                                } else {
                                    unlock();
                                }
                            }}
                            titles={{
                                header: "Копировать информацию о всех промокодах",
                            }}
                            // modal={{
                            //     title: "Копировать информацию о всех промокодах",
                            //     width: "500px"
                            // }}
                            mode={"func"}
                            trigger={(click) => (
                                <div
                                    style={{ padding: (size === "medium" || size === "small") ? "5px 7px" : undefined, width: "100%", minWidth: "92px", fontSize: (size === "medium" || size === "small") ? "12px" : "14px" }}
                                    className={`btn btn-outline-secondary btn-sm`}
                                    onClick={click}
                                >
                                    {(!size) && <span>Копировать</span>}
                                    {(size === "small") && <span><i className="fa fa-clipboard"></i></span>}
                                    {(size === "medium") && <span><i className="fa fa-clipboard"></i> Копировать</span>}
                                    {(size === "large") && <span><i className="fa fa-clipboard"></i> Копировать</span>}
                                </div>
                            )}
                            steps={[
                                {
                                    key: "request",
                                    name: "Шаг 1",
                                    form: (props) => {
                                        const { auth, form, submit } = props;
                                        return (
                                            <Form
                                                form={form}
                                                onFinish={submit}
                                                labelAlign={"left"}
                                                layout={"vertical"}
                                                initialValues={{
                                                    short: true
                                                }}
                                            >
                                                <Form.Item name="short" valuePropName="checked">
                                                    <Checkbox>
                                                        Не выводить размер скидок
                                                    </Checkbox>
                                                </Form.Item>
                                            </Form>
                                        )
                                    },
                                    action: (values, unlock, close) => {
                                        close({ text: buildData(values) });
                                    },
                                },
                                {
                                    key: "view",
                                    name: "Шаг 2",
                                    noAntForm: true,
                                    okText: "Копировать",
                                    form: (props) => {
                                        let text = props?.data?.request?.text || ""
                                        // console.log(props?.data);
                                        return (
                                            <div>
                                                <div style={{ maxHeight: "600px", overflow: "auto", padding: "10px" }}>
                                                    <pre>
                                                        {text}
                                                    </pre>
                                                </div>
                                            </div>
                                        )
                                    },
                                }
                            ]}
                        />}
                    />}
                    <div style={{ padding: "0 10px" }}>
                        <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
                            <div style={{ flex: "1 1 50%" }}>
                                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                    <div>

                                        <div><ObjectVtpDescription object={vtp} fontSize="16px" fontWeight="bold" /></div>
                                        {promokod?.promokod?.AgentskoeVoznagrazhdenieProtsent && <div style={{ display: "flex", gap: "5px" }}>
                                            <div>Вознаграждение агента:</div>
                                            <div>{promokod?.promokod?.AgentskoeVoznagrazhdenieProtsent}%</div>
                                        </div>}
                                    </div>
                                    <div style={{ display: "flex" }}>
                                        <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                            <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "4px" }}>
                                                <div style={{ fontSize: "12px" }}>Промокод:</div>
                                                <CopyToClipboard text={promokod?.promokod?.Promokod?.promokod}
                                                    onCopy={() => message.success("Скопировано")}>
                                                    <Button size='small' style={{
                                                        fontSize: "12px",
                                                        height: "20px",
                                                        padding: "0px 5px",
                                                        borderRadius: "4px"
                                                    }}>
                                                        <i className="fa fa-clipboard" style={{ fontSize: "10px" }}></i>
                                                    </Button>
                                                </CopyToClipboard>
                                            </div>

                                            <div style={{ overflowWrap: "anywhere", fontSize: "24px", backgroundColor: color, padding: "4px 20px", borderRadius: "4px" }}>
                                                {promokod?.promokod?.Promokod?.promokod}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ flex: "1 1 50%" }}>
                                <div>
                                    Скидка по промокоду для покупателя:
                                </div>
                                <div style={{ border: "1px solid rgba(50, 50, 50, 0.15)", borderRadius: "4px", padding: "10px" }}>
                                    {JSXMap(promokod?.promokod?.Promokod?.promokodiVYacheikakhPromokod, (e, idx) => {
                                        return (<div className='bg bg-fwhite pointer' key={idx} style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
                                            {e?.yacheikaUslugi && <div>{e?.yacheikaUslugi?.nazvanie}</div>}
                                            <div>
                                                {!!e?.protsentObshcheiSummiUslugiNaMeropriyatii && <div>{e?.protsentObshcheiSummiUslugiNaMeropriyatii}%</div>}
                                                {!!e?.rubleiOtObshcheiSummiUslugiNaMeropriyatii && <div>{e?.rubleiOtObshcheiSummiUslugiNaMeropriyatii} руб.</div>}
                                            </div>
                                        </div>)
                                    })}
                                </div>
                            </div>
                        </div>
                        {(promokod?.promokodiPrepodov2Uroven?.length > 0) && <div style={{ paddingTop: "20px" }}>
                            <div className='bg bg-grey' style={{ fontSize: "16px", fontWeight: "bold", textAlign: "left", padding: "0 5px", marginBottom: "5px" }}>Преподаватели школы</div>
                            {JSXMap(promokod?.promokodiPrepodov2Uroven, (item, idx) => (
                                <div key={idx} style={{ display: "flex", gap: "20px", flexWrap: "wrap", borderBottom: "1px solid #e9e9e9", padding: "10px 0" }}>
                                    <div style={{ flex: "1 1 50%" }}>
                                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                            <div>
                                                <User item={item?.Vtp?.user} noborder={true} />
                                                {item?.AgentskoeVoznagrazhdenieProtsent && <div style={{ display: "flex", gap: "5px" }}>
                                                    <div>Вознаграждение агента:</div>
                                                    <div>{item?.AgentskoeVoznagrazhdenieProtsent}%</div>
                                                </div>}
                                            </div>
                                            {!item?.ErrorText && <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "4px" }}>
                                                    <div style={{ fontSize: "12px" }}>Промокод:</div>
                                                    <CopyToClipboard text={item?.Promokod?.promokod}
                                                        onCopy={() => message.success("Скопировано")}>
                                                        <Button size='small' style={{
                                                            fontSize: "12px",
                                                            height: "20px",
                                                            padding: "0px 5px",
                                                            borderRadius: "4px"
                                                        }}>
                                                            <i className="fa fa-clipboard" style={{ fontSize: "10px" }}></i>
                                                        </Button>
                                                    </CopyToClipboard>
                                                </div>
                                                <div style={{ overflowWrap: "anywhere", fontSize: "20px", backgroundColor: color, padding: "4px 20px", borderRadius: "4px" }}>
                                                    {item?.Promokod?.promokod}
                                                </div>
                                            </div>}
                                        </div>
                                    </div>
                                    {item?.ErrorText && <div style={{ display: "flex", alignItems: "center" }}>
                                        <div>
                                            <div style={{ color: "red", fontSize: "18px" }}>{item?.ErrorText}</div>
                                            <div>Вы можете указать основу промокода в разделе <Link to={`/app/${xName(promokod?.promokod?.Vtp)}/${xID(promokod?.promokod?.Vtp)}/education/teachers`}>"Настройки" в личном кабинете</Link></div>
                                        </div>
                                    </div>}
                                    {(!item?.ErrorText && item?.Promokod) && <div style={{ flex: "1 1 50%" }}>
                                        <div>
                                            Скидка по промокоду для покупателя:
                                        </div>
                                        <div style={{ border: "1px solid rgba(50, 50, 50, 0.15)", borderRadius: "4px", padding: "10px" }}>
                                            {JSXMap(item?.Promokod?.promokodiVYacheikakhPromokod, (e, idx) => {
                                                return (<div className='bg bg-fwhite pointer' key={idx} style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
                                                    {e?.yacheikaUslugi && <div>{e?.yacheikaUslugi?.nazvanie}</div>}
                                                    <div>
                                                        {!!e?.protsentObshcheiSummiUslugiNaMeropriyatii && <div>{e?.protsentObshcheiSummiUslugiNaMeropriyatii}%</div>}
                                                        {!!e?.rubleiOtObshcheiSummiUslugiNaMeropriyatii && <div>{e?.rubleiOtObshcheiSummiUslugiNaMeropriyatii} руб.</div>}
                                                    </div>
                                                </div>)
                                            })}
                                        </div>
                                    </div>}
                                </div>
                            ))}
                        </div>}
                        <div style={{ padding: "15px 0" }}>
                            <Button style={{ width: "100%" }} onClick={create}>Обновить</Button>
                        </div>
                    </div>
                </div>}
            </div>
        </PageLayout>
    );
}
